import { FieldArray } from 'formik';
import {
  IQuickVideoCategoryOption,
  IQuickVideoPartOption,
  IQuickVideoPartPositionOption,
} from 'lib/api/quickVideo/types';
import { FormikDropdownField } from 'lib/components/formik/FormikDropdown';
import { FormikInputField } from 'lib/components/formik/FormikInputField';
import { Gap } from 'lib/components/styles/layout';
import React from 'react';
import { VideoPositionComponent } from '../VideoPositionComponent';
import { Dictionary } from 'lodash';
import { useTheme } from 'styled-components/macro';
import { Typography } from 'react-covideo-common';
import { useTranslation } from 'react-i18next';

type QuickVideoDetailsFormProps = {
  categoryOptions: IQuickVideoCategoryOption[];
  videoPositionDropdowns: IQuickVideoPartPositionOption[];
  allVideoPartOptions: Dictionary<IQuickVideoPartOption[]>;
};

export const QuickVideoDetailsForm = ({
  categoryOptions,
  videoPositionDropdowns,
  allVideoPartOptions,
}: QuickVideoDetailsFormProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const translatedCategoryOptions = categoryOptions.map(option => ({
    ...option,
    label: t(option.label),
  }));
  return (
    <Gap flexDirection='column' width='100%' gap='10px'>
      <Gap flexDirection='row' width='100%' gap={'40px'} justifyContent='start'>
        <Typography
          variant='small'
          fontWeight={600}
          color={theme.colors.neutral[80]}
        >
          {t('Video Details')}
        </Typography>
        <Typography
          variant='small'
          fontWeight={500}
          color={theme.colors.primary[100]}
        >
          * {t('indicates a required field')}
        </Typography>
      </Gap>
      <FormikDropdownField
        name='category'
        label={t('Message Category')}
        isRequired
        options={translatedCategoryOptions}
        extendStyles={{
          labelStyles: {
            color: theme.colors.neutral[80],
          },
        }}
      />

      <Gap
        flexDirection='row'
        width='100%'
        flexWrap='nowrap'
        alignItems='flex-start'
      >
        <FormikInputField
          name='name'
          label={t('Video Name')}
          maxLength={60}
          showCounter
          isRequired
          placeholder={t('Enter video name')}
          extendStyles={{
            labelStyles: {
              color: theme.colors.neutral[80],
            },
            inputStyles: {
              paddingRight: '50px',
            },
          }}
        />
        <FormikInputField
          name='description'
          label={t('Video Description')}
          maxLength={60}
          showCounter
          isRequired={false}
          placeholder={t('Enter video description')}
          extendStyles={{
            labelStyles: {
              color: theme.colors.neutral[80],
            },
            inputStyles: {
              paddingRight: '50px',
            },
          }}
        />
      </Gap>
      <Gap flexDirection='row' width='100%' flexWrap='nowrap'>
        <FieldArray name='quickVideoParts'>
          {({ replace }) =>
            videoPositionDropdowns.map((vpd, index) => (
              <VideoPositionComponent
                options={allVideoPartOptions[vpd.value] || []}
                quickVideoPart={vpd}
                replace={replace}
                index={index}
              />
            ))
          }
        </FieldArray>
      </Gap>
    </Gap>
  );
};
